import LookupPlugin from './lookup-plugin';
import PicklistPlugin from './picklist-plugin';
import AddressPlugin from './address-plugin';
import LocalePlugin from './locale-plugin';
import DealThousands from './dealThousands';
export const plugins = [
  LookupPlugin,
  PicklistPlugin,
  AddressPlugin,
  LocalePlugin,
  DealThousands
];



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/index.js